export const tooltipTheme = {
  color: 'white',
  key: 'white',
  overlayInnerStyle: { color: 'black' },
  fontWeightStrong: 400,
}